import type { Session } from "./api";

/**
 * What this principal may do, for drawing the interface.
 *
 * The server sends the permission list so the client can leave out an
 * affordance rather than offer one that will be refused. It is not the
 * control: every endpoint refuses on its own, whatever is drawn. A hidden
 * button has never been an access control.
 */
export interface Ability {
  can(permission: string): boolean;
  /** Acting on a clock follows the party the clause obliges, not seniority. */
  canActOn(responsible: string): boolean;
}

export function makeAbility(session: Session): Ability {
  const permissions = new Set(session.permissions);
  const roles = new Set(session.roles);
  return {
    can: (permission) => permissions.has(permission),
    canActOn: (responsible) =>
      permissions.has("act_on_clock") && roles.has(responsible),
  };
}
